export default __webpack_public_path__ + "static/media/MT.281fe0aa.svg";